import { METRIC_NAME, METRIC_NAME_FORTER_READY, JS_SERVER_TYPE } from '@/constants/index.ts';
import { monitorSingleJsLoadTime } from '@/utils/index.ts';
import { asyncLoadFile } from '@/utils/asyncLoadFile.ts';
import { smartReport } from '@/utils/metricHelper.ts';

let forterDeviceId = '';
let forterSiteId = '';
export async function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['forter'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'], site_from: string }) {
    const { url, not_us } = data
    window?.document?.addEventListener('ftr:tokenReady', function (evt: any) {
        forterDeviceId = evt.detail || forterDeviceId || ''
        window.__forterDeviceId = forterDeviceId
        smartReport({
            metric_name: METRIC_NAME_FORTER_READY,
            tags: { url, type: 'loadSDKForterReady' },
            value: 1,
            message: 'forter load success',
            params: {
                forterDeviceId,
                evt
            }
        })
    })
    forterSiteId = 'cc376223223c'
    //FORTER_NOT_US为1时，us和非us都是同一个siteId，为0时区分美国和非美
    //默认灰度 & 生产的非美值 cc376223223c
    const isDev = extra.env === 'development'
    forterSiteId = isDev ? '9dad99c93b0e' : 'cc376223223c'
    if (not_us == 1) {
        forterSiteId = isDev ? 'f3cf410d78da' : 'fdfe4ed62699'
    } else {
        if (isDev) {
            //测试环境目前没分美国和非美服务器，先用siteuid来判断
            if (extra.site_from.includes('us')) {
                forterSiteId = 'b044e212c01e'
            }
        } else {
            //灰度&生产的美国
            if (extra.server_type == 'us') {
                forterSiteId = 'ffb9ca7033a3'
            }
        }
    }
    window.forterSiteId = window.__forterSiteId = forterSiteId
    loadScript(url, extra.env, extra.server_type);
}

const loadScript = (url: string, env: string, server_type: string) => {
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    }).then(() => {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadForter' },
            value: 1,
            message: 'forter load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime('forter', JS_SERVER_TYPE[env][server_type]);
    })
        .catch(error => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadForterError' },
                value: 1,
                message: 'forter load error',
                params: error
            })
        })
}

export function provideForterDeviceId() {
    return forterDeviceId || ''
}

export function provideForterSiteId() {
    return forterSiteId || ''
}